import React from 'react';
import ReactMarkdown from 'react-markdown';
import GallerySection from "./GallerySection";
import ZoomableImage from './ZoomableImage';
import ListSection from "./ListSection";
import {
    GALLERY,
    IMAGE,
    ORDEREDLIST,
    PARAGRAPH,
    SUBTITLE,
    TITLE,
    UNORDEREDLIST,
    ZOOMABLEIMAGE
} from "../../../../components/sectionTypes";

export default function(section) {
    const type = section.type;
    const key = section.key;

    if (type === TITLE) {
        return (
            <h3 className="mt-7 mb-5" key={key}>{section.content}</h3>
        );
    }

    if (type === SUBTITLE) {
        return (
            <h4 className="mt-7 mb-5" key={key}>{section.content}</h4>
        );
    }

    if (type === PARAGRAPH) {
        return (
            <ReactMarkdown className={"text-justify"} key={key} source={section.content}/>
        );
    }

    if (IMAGE === type) {
        return (
            <img key={key} src={section.url} className="figure-img img-fluid mx-auto d-block my-2"/>
        );
    }

    if (type === ZOOMABLEIMAGE) {
        return(
          <ZoomableImage key={key} url={section.url}/>
        );
    }

    if (type === GALLERY) {
        return (
            <GallerySection key={key} slides={section.slides}/>
        );
    }

    if (type === UNORDEREDLIST || type === ORDEREDLIST) {
        return(
            <ListSection {...section} />
        );
    }

    return (
        <p key={key}>{type}</p>
    );
}


// WEBPACK FOOTER //
// ./src/visitors/components/post/sections/sectionChooser.js